'use client';
import { CheckIcon } from '@chakra-ui/icons';
import { Box, Text } from '@chakra-ui/react';
import { useRadio, UseRadioProps } from '@chakra-ui/react';
import cn from 'classnames';

import Styles from './ColorPicker.module.scss';

interface colorPickerProps extends UseRadioProps {
  colorName: string;
  colorPrimary: string;
  colorSecondary?: string | null;
  withLable?: boolean;
  size?: string;
  disabled?: boolean;
  extraClass?: string;
  additionalCosts?: string | null;
  single?: boolean;
}

const ColorPicker = (props: colorPickerProps) => {
  const {
    colorName,
    colorPrimary,
    colorSecondary,
    withLable = false,
    size = 'md',
    disabled = false,
    extraClass = '',
    additionalCosts,
    single = false,
    ...radioProps
  } = props;
  const { state, getInputProps, getRadioProps, htmlProps, getLabelProps } =
    useRadio(radioProps);

  return (
    <Box
      as="label"
      {...htmlProps}
      className={cn(
        Styles.colorPicker,
        size === 'sm' && Styles.colorPickerSM,
        state.isChecked && Styles.active,
        single === true && Styles.colorPickerSingle,
      )}
      cursor={disabled ? 'default' : 'pointer'}
      role="button"
      aria-label={colorName}
    >
      <input {...getInputProps({})} hidden disabled={disabled} />

      <Box
        {...getRadioProps()}
        className={cn(
          Styles.colorBox,
          { [Styles[extraClass] as string]: extraClass },
          extraClass,
        )}
        backgroundColor={colorPrimary}
        title={colorName}
      >
        {additionalCosts && <Box className={Styles.additionalCosts}>+R</Box>}
        {colorSecondary && colorSecondary?.trim().length && (
          <Box className={Styles.colorSecondary}>
            <Box
              className={Styles.twoToneColor}
              backgroundColor={colorSecondary}
              {...getLabelProps()}
            />
          </Box>
        )}

        {state.isChecked && (
          <>
            {single == false && (
              <Box className={Styles.activeColor}>
                <CheckIcon color={'white'} />
              </Box>
            )}
          </>
        )}
      </Box>
      {withLable == true && (
        <Text
          fontSize="sm"
          className={Styles.colorNameLabel}
          mt={2}
          display={{ base: 'none', lg: 'block' }}
        >
          {single == false && <Text as="b">Paint:</Text>} {colorName}
        </Text>
      )}
    </Box>
  );
};

export default ColorPicker;
